module.exports = __webpack_public_path__ + "static/media/img07.b4533333.png";